<template>
  <div
    class="hello"
    id="hello"
    style="position: relative; height: 500px; width: 100%;"
  >
    <div
      id="canvas_wrapper"
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    ></div>
    <div
      id="Atoms"
      ref="Atoms"
      style="
        position: absolute;
        left: 0;
        top: 0;
        z-index: 4;
        display: inline-block;
      "
    >
      <div
        v-for="(atom, index) in Atoms"
        :class="atom.label"
        class="atom"
        :key="index"
      >
        <div class="label-atom">{{ atom.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import MolecularModel from "../utils/molecular/model";
import { mapState } from "vuex";

export default {
  name: "MoleDrawer",
  props: {
    detail: Object,
  },
  data: () => ({
    structure: {},
    Atoms: [],
  }),
  mounted() {
    setTimeout(() => {
      try {
        this.structure = { data: this.detail.data, type: this.detail.type };
        MolecularModel.init("canvas_wrapper");
        this.createALl();
        this.$emit("closeLoading");
      } catch (e) {
        this.$emit("closeLoading", "error");
      }
    });
  },
  computed: {
    ...mapState(["listWhat"]),
  },
  methods: {
    changeAtomColor() {
      for (let Atom of this.Atoms) {
        let atom = document.getElementsByClassName(Atom.label);
        setTimeout(() => {
          atom[0].style.background = Atom.rgb;
        });
      }
    },
    createALl() {
      if (this.structure) {
        MolecularModel.createMolecule(this.structure);
        this.Atoms = MolecularModel.Atoms;
        this.changeAtomColor();
      }
    },
  },
  destroyed() {
    MolecularModel.dispose();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.atom {
  border: 2px solid #333;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-top: 10px;
  position: relative;
}

.label-atom {
  position: absolute;
  top: -7px;
  left: 24px;
  font-size: 20px;
}

#hello {
  position: relative;
  height: 480px;
}

.mole-canvas {
  width: 100% !important;
  min-width: 450px;
  height: 100% !important;
}
</style>
